<h5>Ok to Proceed?</h5>
<p>{{fromPage}}</p>
<button mat-flat-button class="dlg-button-margin-r" color="warn" (click)="yesDialog()">Ok</button>
<button mat-flat-button class="dlg-button-margin-r" color="primary" (click)="cancelDialog()">Cancel</button>